import Sourcing from './sourcing';

export default [...Sourcing];
